module.exports = __webpack_public_path__ + "static/media/githubLight.2be16e2d.svg";